import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

import FindStep1 from 'js/containers/stack/find/Find.step-1';
import FindStep2 from 'js/containers/stack/find/Find.step-2';

const FindIndex = () => {
  // import hooks
  const { step2 = false } = useRouteInfo().state || {};

  const [currentStep, setCurrentStep] = React.useState(step2 ? STEPS.STEP_2 : STEPS.STEP_1);

  const motionWrapper = (id, child) => {
    return (
      <motion.div key={`find-step-${id}`} variants={variants} initial="initial" animate="animate" exit="exit">
        {child}
      </motion.div>
    );
  };

  return (
    <AnimatePresence mode="wait">
      {currentStep === 1 &&
        motionWrapper(
          1,
          <FindStep1
            setCurrentStep={() => {
              setCurrentStep(STEPS.STEP_2);
            }}
          />
        )}
      {currentStep === 2 &&
        motionWrapper(
          2,
          <FindStep2
            setCurrentStep={() => {
              setCurrentStep(STEPS.STEP_1);
            }}
          />
        )}
    </AnimatePresence>
  );
};

export default FindIndex;

const variants = {
  initial: {
    opacity: 0,
    y: 80,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 120,
      damping: 18,
      mass: 0.8,
    },
  },
  exit: {
    opacity: 0,
    y: 80,
    filter: 'blur(4px)',
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  },
};

const STEPS = {
  STEP_1: 1,
  STEP_2: 2,
};
